import { render, staticRenderFns } from "./listComment.vue?vue&type=template&id=5f024c26&"
import script from "./listComment.vue?vue&type=script&lang=js&"
export * from "./listComment.vue?vue&type=script&lang=js&"
import style0 from "./listComment.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./listComment.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports